import { Eyebrow } from "../atoms/Eyebrow";
import { Reveal } from "../atoms/Reveal";
import type { Copy } from "../lib/copy";

type IndustriesProps = { t: Copy };

/**
 * Auto-running horizontal marquee of industry cards. The track is the source
 * list duplicated inline so a CSS `translateX(-50%)` animation produces a
 * seamless infinite loop. Pauses on hover so users can read a card.
 *
 * Page scroll is intentionally untouched — wheel/touch behave normally.
 */
export function Industries({ t }: IndustriesProps) {
  const originalLength = t.industries.items.length;
  const loopedItems = [...t.industries.items, ...t.industries.items];

  return (
    <section id="industries" className="section industries">
      <div className="container">
        <div className="section-head">
          <Reveal>
            <Eyebrow>{t.industries.eyebrow}</Eyebrow>
          </Reveal>
          <Reveal as="h2" className="section-title" delay={60}>
            <span className="ink">{t.industries.title_a}</span>{" "}
            <span className="serif-accent">{t.industries.title_b}</span>
          </Reveal>
        </div>
      </div>

      <div className="industry-marquee">
        <div className="industry-marquee-track">
          {loopedItems.map((it, i) => {
            const isClone = i >= originalLength;
            return (
              <article
                key={i}
                className="industry-card"
                aria-hidden={isClone ? "true" : undefined}
              >
                <div className="ic-top">
                  <span className="ic-tag">{it.tag}</span>
                </div>
                {it.image && (
                  <div className="ic-image">
                    <img
                      src={it.image}
                      alt={isClone ? "" : it.title}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                )}
                <h3 className="ic-title">{it.title}</h3>
                <p className="ic-body">{it.body}</p>
                <ul className="ic-bullets">
                  {it.bullets.map((b, j) => (
                    <li key={j}>
                      <span className="tick" />
                      {b}
                    </li>
                  ))}
                </ul>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
